import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/w/$ws/dm/$channel/t/$root")({ component: () => null });
